<script setup lang="ts">import { useGameStore as ___useGameStore } from "@client/stores"; const $$game =  ___useGameStore();import { $socket } from "@client/lib/socket";
import Social from "@client/components/core/Social";
import Header from "@client/components/ui/Header.vue";
import Footer from "@client/components/ui/Footer.vue";
import {
	ResizableHandle,
	ResizablePanel,
	ResizablePanelGroup,
} from "@client/components/ui/resizable/index";
import { sounds } from "@client/composables/audio";

const user = $$game.players.user;
const opponent = $$game.players.opponent;

const messages = ref([] as { isSelf: boolean; content: string }[]);

const newMessage = ref("");
function handleMessageSend() {
	if (newMessage.value.trim() === "") return;
	sounds.message.play();
	if (messages.value.length === 37) messages.value.shift();
	messages.value.push({
		isSelf: true,
		content: newMessage.value,
	});
	$socket.game.emit("userSentSelectionChat", newMessage.value);
	newMessage.value = "";
}

$socket.game.on("opponentSentSelectionChat", (data) => {
	if (messages.value.length === 37) messages.value.shift();
	messages.value.push({
		isSelf: false,
		content: data,
	});
	sounds.message.play();
});
</script>
<template>
	<Header />
	<ResizablePanelGroup direction="horizontal">
		<ResizablePanel :defaultSize="88"><slot /></ResizablePanel>
		<ResizableHandle with-handle />
		<ResizablePanel :defaultSize="12">
			<aside v-if="$$game.mode == 'single'" class="tw:flex-col tw:flex tw:h-full">
				<Social />
			</aside>

			<aside
				v-if="$$game.mode === 'unranked'"
				class="tw:[box-shadow:0px_1px_1px_1px_rgb(62_62_62)] tw:h-full tw:text-[11px] tw:overflow-y-hidden tw:flex
					tw:flex-col tw:justify-end tw:px-6">
				<ul
					class="tw:border-b tw:border-b-[rgba(255,255,255,0.1)] tw:overflow-y-auto tw:overflow-x-hidden tw:py-2
						tw:max-h-[80vh] thin-scrollbar">
					<li
						v-for="message in messages"
						class="tw:grid tw:grid-cols-[2.5rem,100fr] tw:py-0.5">
						<span
							:class="
								message.isSelf
									? 'tw:text-(--accent-color-darker)'
									: 'tw:text-cyan-800'
							"
							class="tw:font-bold tw:truncate tw:col-span-1 tw:uppercase">
							{{ message.isSelf ? user.info.username : opponent.info.username }}
						</span>
						<span class="tw:text-[#ffffffb2] tw:col-span-1">
							{{ message.content }}
						</span>
					</li>
				</ul>

				<div
					class="tw:pb-4 tw:text-[10px] tw:text-[#ffffff78] tw:flex tw:justify-between tw:items-center">
					<input
						@keypress.enter="handleMessageSend"
						v-model="newMessage"
						type="text"
						placeholder="Enter your message"
						class="tw:py-2 tw:px-3 tw:w-full" />
				</div>
			</aside>
		</ResizablePanel>
	</ResizablePanelGroup>
	<Footer />
</template>
